import React, { useEffect, useState } from 'react'
import { RecruiterResponse } from '../Types/RecruiterTypes';
import { getRecuiterById } from '../Services/RecruiterService';
import RecruiterProfile from '../Components/RecruiterProfile';

function RecruiterEditProfilePage() {

      
  return (
    <div>
     <RecruiterProfile/>
    </div>
  )
}

export default RecruiterEditProfilePage